import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D9DCDF",
      d: "M10.23 1.577a3.984 3.984 0 0 1 4.13 0l5.31 3.217c.437.265.812.607 1.112 1.003.075.1.043.24-.063.305l-7.859 4.76c-.347.211-.783.211-1.13 0l-7.86-4.76a.209.209 0 0 1-.062-.305c.3-.396.674-.738 1.112-1.003l5.31-3.217ZM3.361 7.45c-.127-.077-.291-.007-.314.14-.031.2-.047.403-.047.609v6.712c0 1.394.728 2.686 1.92 3.408l5.31 3.217c.347.21.718.363 1.1.458a.208.208 0 0 0 .255-.206v-8.74c0-.383-.2-.737-.526-.934L3.361 7.45ZM13.004 21.787c0 .136.123.24.255.207a3.98 3.98 0 0 0 1.1-.458l5.31-3.218a3.984 3.984 0 0 0 1.92-3.407V8.198c0-.205-.017-.409-.047-.609-.023-.146-.188-.216-.315-.14l-7.697 4.664a1.092 1.092 0 0 0-.526.934v8.74Z"
    }, null, -1)
  ])))
}
export default { render: render }